import React from "react";

export const Ast = () =>  {
    return <span style={{ color: "#f5222d" }}>*</span>;
}